var _rect, _rect2, _rect3, _rect4, _rect5, _ellipse, _rect6, _rect7, _rect8, _rect9, _rect10, _ellipse2, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcEstateAllStep5(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 51,
    viewBox: "0 0 56 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 12.3203,
    y: 18.9785,
    width: 37.2375,
    height: 7.83948,
    rx: 3.91974,
    fill: "#EEC2B9"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2.12695,
    y: 23.9082,
    width: 36.6473,
    height: 10.9546,
    rx: 5.47732,
    transform: "rotate(-35 2.12695 23.9082)",
    fill: "#EEC2B9"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 12.3203,
    y: 26.8184,
    width: 43.1171,
    height: 7.83948,
    rx: 3.91974,
    fill: "#EEC2B9"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 12.3203,
    y: 34.6572,
    width: 39.1974,
    height: 7.83948,
    rx: 3.91974,
    fill: "#EEC2B9"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 12.3203,
    y: 42.4971,
    width: 35.2776,
    height: 7.83948,
    rx: 3.91974,
    fill: "#EEC2B9"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 16.2395,
    cy: 33.6784,
    rx: 15.679,
    ry: 16.6589,
    fill: "#EEC2B9"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 12.3203,
    y: 16.7549,
    width: 37.2372,
    height: 7.83942,
    rx: 3.91971,
    fill: "#FFDCD5"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 2.12891,
    y: 21.6826,
    width: 36.647,
    height: 10.9546,
    rx: 5.47728,
    transform: "rotate(-35 2.12891 21.6826)",
    fill: "#FFDCD5"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 12.3203,
    y: 24.5938,
    width: 43.1168,
    height: 7.83942,
    rx: 3.91971,
    fill: "#FFDCD5"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 12.3203,
    y: 32.4336,
    width: 39.1971,
    height: 7.83942,
    rx: 3.91971,
    fill: "#FFDCD5"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 12.3203,
    y: 40.2725,
    width: 35.2774,
    height: 7.83942,
    rx: 3.91971,
    fill: "#FFDCD5"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 16.2394,
    cy: 31.4537,
    rx: 15.6788,
    ry: 16.6588,
    fill: "#FFDCD5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1172 37.5476C20.1976 37.5476 26.7742 31.5655 27.7749 20.6748C30.7157 25.3416 30.7157 35.2735 28.4528 44.5767",
    stroke: "#EEC2B9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcEstateAllStep5);
export default __webpack_public_path__ + "static/media/IcEstateAllStep5.d8d48c65e6d7460cf2094aeaec81e97b.svg";
export { ForwardRef as ReactComponent };